import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        aiMachineInfo: '',
		aiMachineCode: localStorage.getItem('ai_machine_code') || null,
        aiScreen: localStorage.getItem('ai_screen')==1 ? true : false,
        aiPrint: localStorage.getItem('ai_print')==1 ? true : false,
        aiHomeBgmEnabled: localStorage.getItem('ai_home_bgm_enabled')==1 ? true : false,
        aiFileStore: {},
        aiFileStore2: {},
        aiFileStore3: {},
        birthdayMachineInfo: '',
		birthdayMachineCode: localStorage.getItem('birthday_machine_code') || null,
        birthdayClient: localStorage.getItem('birthday_client')==1 ? true : false,
        birthdayScreen: localStorage.getItem('birthday_screen')==1 ? true : false,
        birthdayPrint: localStorage.getItem('birthday_print')==1 ? true : false,
	},
	getters: {
		aiMachineInfo: state => state.aiMachineInfo ? JSON.parse(state.aiMachineInfo) : {},
		aiMachineCode: state => state.aiMachineCode,
		aiScreen: state => state.aiScreen,
		aiPrint: state => state.aiPrint,
		aiHomeBgmEnabled: state => state.aiHomeBgmEnabled,
		aiFileStore: state => state.aiFileStore,
		aiFileStore2: state => state.aiFileStore2,
		aiFileStore3: state => state.aiFileStore3,
		birthdayMachineInfo: state => state.birthdayMachineInfo ? JSON.parse(state.birthdayMachineInfo) : {},
		birthdayMachineCode: state => state.birthdayMachineCode,
		birthdayClient: state => state.birthdayClient,
		birthdayScreen: state => state.birthdayScreen,
		birthdayPrint: state => state.birthdayPrint,
	},
	mutations: {
		// 设置设备信息
		setAiMachineInfo(state, value) {
			state.aiMachineInfo = JSON.stringify(value) ?? '';
		},
		// 设置设备code
		setAiMachineCode(state, value) {
			state.aiMachineCode = value;
			localStorage.setItem('ai_machine_code', value);
		},
		// 设置屏幕
		setAiScreen(state, value) {
			state.aiScreen = value;
			localStorage.setItem('ai_screen', value?1:0);
		},
		// 设置打印
		setAiPrint(state, value) {
			state.aiPrint = value;
			localStorage.setItem('ai_print', value?1:0);
		},
		// AI首页背景音乐，默认关闭
		setAiHomeBgmEnabled(state, value) {
			state.aiHomeBgmEnabled = value === true || value == 1;
			localStorage.setItem('ai_home_bgm_enabled', state.aiHomeBgmEnabled ? 1 : 0);
		},
		setAiFileStore(state, value) {
			state.aiFileStore = value;
		},
		setAiFileStore2(state, value) {
			state.aiFileStore2 = value;
		},
		setAiFileStore3(state, value) {
			state.aiFileStore3 = value;
		},
		// 设置设备信息
		setBirthdayMachineInfo(state, value) {
			state.birthdayMachineInfo = JSON.stringify(value) ?? '';
		},
		// 设置设备code
		setBirthdayMachineCode(state, value) {
			state.birthdayMachineCode = value;
			localStorage.setItem('birthday_machine_code', value);
		},
		// 设置用户端信息
		setBirthdayClient(state, value) {
			state.birthdayClient = value;
			localStorage.setItem('birthday_client', value?1:0);
		},
		// 设置屏幕
		setBirthdayScreen(state, value) {
			state.birthdayScreen = value;
			localStorage.setItem('birthday_screen', value?1:0);
		},
		// 设置打印
		setBirthdayPrint(state, value) {
			state.birthdayPrint = value;
			localStorage.setItem('birthday_print', value?1:0);
		},
	},
	actions: {
	},
	modules: {
	}
})
